import { ModelInputs, numberKeys } from "./types";

/** Generic validator – configurable per view */
export function validateInputs(
  inputs: ModelInputs,
  opts: {
    requiredKeys: readonly (keyof ModelInputs)[];
    requireGenIfExisting?: boolean;
  }
) {
  const missing = new Set<keyof ModelInputs>();
  const badNumbers = new Set<keyof ModelInputs>();

  for (const k of opts.requiredKeys) {
    const v = inputs[k];
    if (v === "" || v === null || v === undefined) {
      missing.add(k);
      continue;
    }
    if ((numberKeys as readonly (keyof ModelInputs)[]).includes(k)) {
      if (Number.isNaN(Number(v))) badNumbers.add(k);
    }
  }

  if (opts.requireGenIfExisting && inputs.existing_project_flag) {
    if (!Array.isArray(inputs.gen_hour_profile_mw) || inputs.gen_hour_profile_mw.length === 0) {
      missing.add("gen_hour_profile_mw");
    }
  }

  return {
    valid: missing.size === 0 && badNumbers.size === 0,
    missing,
    badNumbers,
  };
}
